module.exports = __webpack_public_path__ + "assets/f39489864b0ec10d2f2f832f24193b06.png";